import React from "react";

export const PracticeIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28px"
        height="28px"
        viewBox="0 0 32 32"
        version="1.1"
      >
        <g
          stroke="none"
          fillRule="evenodd"
          fill="none"
          fillOpacity="1"
          strokeWidth="1"
        >
          <g transform="translate(-162.000000, -55.000000)">
            <g id="practice" transform="translate(162.000000, 55.000000)">
              <rect
                fill="#2ECFE3"
                opacity="0.200000003"
                x="0"
                y="0"
                width="32"
                height="32"
                rx="16"
              ></rect>
              <path
                fill="#2CC6DC"
                fillRule="nonzero"
                d="M15.2962963,8 L15.2962963,9.98726852 C14.2141204,10.2676508 13.4074074,11.2416091 13.4074074,12.4074074 C13.4074074,13.0665509 13.6754917,13.6666667 14.0960648,14.119213 L11.9907407,18.7037037 L9.62962963,18.7037037 L9.62962963,19.962963 L11.400463,19.962963 L9.6099537,23.8587963 L10.7511574,24.3900463 L12.7974537,19.962963 L15.2962963,19.962963 L15.2962963,21.2222222 L16.5555556,21.2222222 L16.5555556,19.962963 L19.0543981,19.962963 L21.0810185,24.3900463 L22.2222222,23.8784722 L20.431713,19.962963 L22.2222222,19.962963 L22.2222222,18.7037037 L19.8611111,18.7037037 L17.755787,14.099537 C18.1714408,13.65191 18.4444444,13.0640916 18.4444444,12.4074074 C18.4444444,11.2416091 17.6377315,10.2676508 16.5555556,9.98726852 L16.5555556,8 L15.2962963,8 Z M15.9259259,11.1481481 C16.6293406,11.1481481 17.1851852,11.7039934 17.1851852,12.4074074 C17.1851852,12.7738714 17.0376157,13.1009841 16.7916667,13.3321759 L16.7719907,13.3518519 L16.1423611,13.6273148 L18.4641204,18.7037037 L16.5555556,18.7037037 L16.5555556,17.4444444 L15.2962963,17.4444444 L15.2962963,18.7037037 L13.3680556,18.7037037 L15.6898148,13.6666667 L15.0601852,13.3715278 L15.0798611,13.3518519 C14.8191554,13.12066 14.6666667,12.7861693 14.6666667,12.4074074 C14.6666667,11.7039934 15.2225119,11.1481481 15.9259259,11.1481481 Z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
